import ListNpvrTask from '../../requests/tasks/npvr/ListNpvrTask';
import RequestManager from '../../requests/RequestManager';
import AddNpvrTask from '../../requests/tasks/npvr/AddNpvrTask';
import SeriesAddNpvrTask from '../../requests/tasks/npvr/SeriesAddNpvrTask';
import SeriesListNpvrTask from '../../requests/tasks/npvr/SeriesListNpvrTask';
import RemoveNpvrTask from '../../requests/tasks/npvr/RemoveNpvrTask';
import { EPGUtil } from '../Nepg/EPGUtil';
import { NpvrUtil } from './NpvrUtil';
import { NPRV_SCHEDULED_STATUS, NPVR_RECORDABLE_EVENT_STATUS, NPVR_RECORDED_STATUS, NPVR_NO_SPACE_TO_RECORD_ERROR_CODE, NPVR_ERROR } from './Constans';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import { convertMinutesToMilliseconds } from '../../AAFPersistenceManager/helpers/Utils';
import {
  UpdateMiniAfterRecordObserver,
  recordFullObserver,
  RecordingsNotification
} from '../../components/PersistentMiniEpg/MiniObserver';
import Translator from '../../requests/apa/Translator';
import ListNpvrFromUrlTask from '../../requests/tasks/npvr/ListNpvrFromUrlTask';
import Utils from '../../utils/Utils';
import SimpleGetRequestTask from '../../requests/tasks/SimpleGetRequestTask';
import {showModal, MODAL_RECORD_SERIES} from '../../actions/modal';
import store from '../../store';
import Npvr from '../../utils/Npvr';
import { convertEventLiveTORecord } from '../../containers/Search/ObserversSearch';
import SearchConstants from '../../containers/Search/SearchConstants';
import {showNoSpaceToRecordNotification, showRecordingNotification } from '../../actions/notification';
import Asset from '../../requests/apa/Asset';
import logger from 'src/utils/logger/logger';

class NpvrUploader {
  constructor() {
    this.recordings = {};
    this.user = null;
    this.idUploader = null;
    this.getRecordings = this.getRecordings.bind(this);
    this.updateLocalRecordings = this.updateLocalRecordings.bind(this);
    this.withDelay = this.withDelay.bind(this);
    this.showNotification = () => {};
    this.idDelay = null;
  }

  getUser() {
    return this.user;
  }

  setUser(user) {
    this.user = user;
  }

  setShowNotification(showNotification) {
    this.showNotification = showNotification;
  }

  withDelay(fn, ms) {
    // this is because some methods in android interface are asynchronous
    if (typeof fn !== 'function' || isNaN(ms)) return;
    if (!this.idDelay) {
      this.idDelay = setTimeout(() => {
        fn();
        clearTimeout(this.idDelay);
        this.idDelay = null;
      }, ms);
    }
  }

  start() {
    if (!this.idUploader) {
      const milliseconds = convertMinutesToMilliseconds(
        NpvrUtil.getTimeToGetRecordings().minutes
      );
      this.idUploader = setInterval(() => {
        this.getRecordings().then(() => this.updateLocalRecordings());
      }, milliseconds);
    }
  }

  stop() {
    clearInterval(this.idUploader);
    this.idUploader = null;
  }

  filterErrorRecordings(recordings = []) {
    return (recordings && Array.isArray(recordings) && recordings.filter(recording => recording.status !== NPVR_ERROR)) || [];
  }

  async getRecordings(recs = null, series = null) {
    try {
      this.recordings = {};
      const result = await this.list();
      const recordings = recs ? this.filterErrorRecordings(recs) : this.filterErrorRecordings(result.recordings) || [];
      const seriesRecordings = series ? series : result.series || [];

      recordings.forEach(recording => {
        const eventAlfId =
          recording.channel && recording.channel.event &&
            recording.channel.event.event_alf_id && recording.channel.event.event_alf_id !== null
              ? recording.channel.event.event_alf_id
              : recording.channel.event.id;

        /**
         * Sólo validar ext_series_id y ext_episode_id
         * por decirlo, "numericos y mayores a 0"
         * Pero:
         * ext_series_id siempre debería ser númerico y mayor a cero
         * ext_episode_id puede ser nulo o 0 porque puede haber episodios piloto o "detrás de escena"
         * y estos últimos pueden tener 0 en el id
         *
         * Entonces en este punto solo validamos por ext_series_id
         */

        // ext_series_id
        let ext_series_id =
          recording.channel && recording.channel.event &&
            recording.channel.event.ext_series_id && (recording.channel.event.ext_series_id !== null || recording.channel.event.ext_series_id !== 'null')
              ? recording.channel.event.ext_series_id
              : 0;

        ext_series_id = parseInt(ext_series_id);

        let record_type = 'program';
        if(ext_series_id > 0) {
          record_type = 'episode';
        }

        const eventId = eventAlfId ? eventAlfId : null;
        const groupId =
          recording.channel && recording.channel.group_id
            ? recording.channel.group_id
            : null;

        if (eventId && groupId) {
          this.recordings[eventId] = {
            id: eventId,
            group_id: groupId,
            recording_status: NpvrUtil.parseStringStatusToInt(recording.status),
            recording_id: `${recording.record_id}`,
            actions: (recording.actions || null),
            recordType: record_type
          };
        }
      });
      await this.getSeriesToSetRecordings(seriesRecordings);
      logger.debug('::: getRecordings', this.recordings);
      return new Promise(resolve => resolve(this.recordings));
    } catch (e) {
      logger.error('[NpvrUploader] getRecordings catch', e);
      return new Promise(resolve => resolve(this.recordings));
    }
  }

  async getLightList() {
    try {
      this.lightList = {};
      const lightListTask = new LightListTask({});
      const response = await RequestManager.addRequest(lightListTask);
      const channels = response && response.data.channels;
      channels && channels.forEach(channel => {
        const recordings = channel.recordings;
        recordings && recordings.forEach(recording => {
          const eventId = recording.event_alf_id;
          this.lightList[eventId] = recording;
        });
      });
      return new Promise(resolve => resolve(this.lightList));
    } catch (error) {
      logger.error('[Error trying to fetch LightListTask]', error);
      return new Promise(resolve => resolve(this.lightList));
    }
  }



  getIsRecordingSerie = (eventId) => {
    if(this.lightList && !this.lightList[eventId]) return false;
    return this.lightList[eventId].is_serie || false;
  }

  async getSeriesToSetRecordings(series = []){
    if(series.length === 0){
      return false;
    }
    else{
      for(let i=0; i<series.length; i++){
        const serie = series[i];
        await this.updateStatusFromListSerieFromURl(serie);
      }
    }
    return true;
  }

  async updateLocalRecordings() {
    const newRecordings = Object.keys(this.recordings).map(key => {
      return this.recordings[key];
    });
    logger.debug(
      '[NpvrUploader] updateLocalRecordings length newRecordings: ' + newRecordings.length
    );
    await EPGUtil.updateRecordings(newRecordings);
  }

  async reminderRecordings() {
    const recordings = Object.keys(this.recordings).map(key => {
      if (
        this.recordings[key] &&
        this.recordings[key].recording_status === NPVR_RECORDED_STATUS
      ) {
        return this.recordings[key];
      }
    });
    logger.debug('[NpvrUploader] reminderRecordings length recordings' + recordings.length);
    this.showNotification({
      show: true,
      title: Translator.get('recording_success', '¡Grabado!'),
      msg: Translator.get(
        'recording_notification_success',
        'Se han completado {{numGrabaciones}} de tus grabaciones'
      ).replace('{{numGrabaciones}}', recordings.length),
      apaAsset: 'player_controls_recording_icon',
      type: 'message'
    });
  }

  isEventRecording(eventId) {
    return this.recordings[eventId] ? true : false;
  }

  getRecordingIdByEventId(eventId) {
    return this.recordings[eventId] ? this.recordings[eventId].recording_id : null;
  }

  getRecordingByEventId(eventId) {
    return this.recordings[eventId] ? this.recordings[eventId] : null;
  }

  getRecordingTypeByEventId(eventId) {
    const recordingRecord =  this.recordings[eventId] ? this.recordings[eventId] : null;
    if(Utils.isNotNullOrNotUndefined(recordingRecord.recordType)) {
      return recordingRecord.recordType;
    }

    return 'program';
  }

  getRecordingDeleteIdByEventId(eventId) {
    const recording = this.recordings[eventId] ? this.recordings[eventId] : null;
    if (recording && recording.actions.delete) {
      const deleteUrl = Utils.urlParamsToJson(recording.actions.delete);
      if(deleteUrl) {
        const recordingDeleteId = Utils.isNotNullOrNotUndefined(deleteUrl.record_id) ? deleteUrl.record_id : null;
        return recordingDeleteId;
      }
    }
    return null;
  }

  getRecordingStatusByEventId(eventId) {
    return this.recordings[eventId]
      ? this.recordings[eventId].recording_status
      : NPVR_RECORDABLE_EVENT_STATUS;
  }

  getAllRecordingStatusByEventId(eventId) {
    return this.recordings[eventId]
      ? this.recordings[eventId]
      : null;
  }


  validateResponse(response) {
    if (response && response.status === 200 && (response.response && response.response.status !== NPVR_ERROR)) {
      return true;
    }
    return false;
  }

  getRecordingFromResponse(response) {
    if (
      response &&
      response.response &&
      response.response.record_id
      // && response.response.status
    ) {
      return {
        recording_id: `${response.response.record_id}`,
        recording_status: NpvrUtil.parseStringStatusToInt(response.response.status || NPRV_SCHEDULED_STATUS),
        actions: (response && response.response && response.response.actions) ? response.response.actions : null
      };
    } else return null;
  }

  showRecordingNotification(response, isEpisode = false, isCancel = false, current_status, cbButton = null, isSerie = false) {
    // Valida si se canceló la grabación
    if(isCancel){
      const status_final_string = `${current_status}_cancel`;
      const statusToNumber = NpvrUtil.parseStringStatusToInt(current_status);
      const status_final = `${statusToNumber}_cancel`;
      let imageAndLabel = NpvrUtil.getRecordingAsset(status_final);
      store.dispatch(showRecordingNotification(status_final_string, cbButton, imageAndLabel, isEpisode, isSerie));
      return;
    }

    // Notificación para evento normal
    const notificationProps = {
      show: true,
      title: Translator.get('recording_started', '¡Grabando!'),
      msg: Translator.get(
        'recording_notification_started',
        'Este programa será agregado a tu sección de Mis grabaciones'
      ),
      apaAsset: 'player_controls_recording_icon',
      type: 'message'
    };

    // Valida la respuesta del servicio
    if (!this.validateResponse(response)) {
      // Valida si el error es por espacio insuficiente
      if (response.code == NPVR_NO_SPACE_TO_RECORD_ERROR_CODE) {
        const status = NPVR_NO_SPACE_TO_RECORD_ERROR_CODE;
        const label = Translator.get(`${response.code}_title`, '');
        const imageSrc = Asset.get(`${response.code}_icon`, '');
        const imageAndLabel = {
          label,
          imageSrc
        }
        store.dispatch(showRecordingNotification(status, cbButton, imageAndLabel, isEpisode));
        return;
      } else {
        notificationProps.title = Translator.get('recording_error', '¡Error!')
        notificationProps.msg = Translator.get(response.code);
        notificationProps.apaAsset = 'player_controls_recording_icon';
        return this.showNotification(notificationProps);
      }
    }

    // Verifica que la respuesta del servicio sea válida
    if(response && response.response && response.response.status){
        const status = response.response.status;
        const statusToNumber = NpvrUtil.parseStringStatusToInt(status);
        let imageAndLabel = NpvrUtil.getRecordingAsset(statusToNumber);
        store.dispatch(showRecordingNotification(status, cbButton, imageAndLabel, isEpisode));
    }
  }

  showRecordingNotificationEpisode(response, cbButton = null, isEpisode = true, isSerie = false) {
    // Notificación para episodio
    const notificationProps = {
      show: true,
      title: Translator.get('npvr_recording_notification_toRecord_title', '¡Grabando!'),
      msg: Translator.get(
        'npvr_recording_notification_episode_description',
        'Este episodio será agregado a tu sección de Mis grabaciones en Mis Contenidos'
      ),
      apaAsset: 'player_controls_recording_icon',
      type: 'message'
    };
    // Valida si la respuesta del servicio
    if (!this.validateResponse(response)) {
      // Valida si el error es por espacio insuficiente
      if (response.code == NPVR_NO_SPACE_TO_RECORD_ERROR_CODE) {
        const status = NPVR_NO_SPACE_TO_RECORD_ERROR_CODE;
        const label = Translator.get(`${response.code}_title`, '');
        const imageSrc = Asset.get(`${response.code}_icon`, '');
        const imageAndLabel = {
          label,
          imageSrc
        }
        store.dispatch(showRecordingNotification(status, cbButton, imageAndLabel, isEpisode, isSerie));
        return;
      } else {
        notificationProps.title = Translator.get('recording_error', '¡Error!')
        notificationProps.msg = response && response.code ? Translator.get(response.code) : "";
        notificationProps.apaAsset = 'player_controls_recording_icon';
        return this.showNotification(notificationProps);
      }
    }

    // Verifica que la respuesta del servicio sea válida
    if(response && response.response && response.response.status){
      const status = response.response.status;
      const statusToNumber = NpvrUtil.parseStringStatusToInt(status);
      let imageAndLabel = NpvrUtil.getRecordingAsset(statusToNumber);
      store.dispatch(showRecordingNotification(status, cbButton, imageAndLabel, isEpisode, isSerie));
    }
  }

  showRecordingNotificationSerie(response, cbButton = null, isEpisode = false, isSerie = true) {
    // Notificación para serie
    const notificationProps = {
      show: true,
      title: Translator.get('npvr_recording_notification_toRecord_title', '¡Grabando!'),
      msg: Translator.get(
        'npvr_recording_notification_serie_description',
        'Esta serie será agregada a tu sección de Mis grabaciones en Mis Contenidos'
      ),
      apaAsset: 'player_controls_recording_icon',
      type: 'message'
    };

    // Valida si la respuesta del servicio
    if (!this.validateResponse(response)) {
      // Valida si el error es por espacio insuficiente
      if (response.code == NPVR_NO_SPACE_TO_RECORD_ERROR_CODE) {
        const status = NPVR_NO_SPACE_TO_RECORD_ERROR_CODE;
        const label = Translator.get(`${response.code}_title`, '');
        const imageSrc = Asset.get(`${response.code}_icon`, '');
        const imageAndLabel = {
          label,
          imageSrc
        }
        store.dispatch(showRecordingNotification(status, cbButton, imageAndLabel, isEpisode, isSerie));
        return;
      } else {
        notificationProps.title = Translator.get('recording_error', '¡Error!')
        notificationProps.msg = Translator.get(response.code);
        notificationProps.apaAsset = 'player_controls_recording_icon';
        return this.showNotification(notificationProps);
      }
    }

    // Verifica que la respuesta del servicio sea válida
    if(response && response.response && response.response.status){
      const status = response.response.status;
      const statusToNumber = NpvrUtil.parseStringStatusToInt(status);
      let imageAndLabel = NpvrUtil.getRecordingAsset(statusToNumber);
      store.dispatch(showRecordingNotification(status, cbButton, imageAndLabel, isEpisode, isSerie));
    }
  }

  async add(eventId, event_alf_id, groupId, channelId, isEpisode = false, cbButton = null) {
    try {
      logger.debug(
        `[NpvrUploader] add eventId: ${eventId}, event_alf_id: ${event_alf_id}, groupId: ${groupId}, channelId: ${channelId}`
      );
      const paywayToken = await new ChannelSingleton().getPaywayToken(groupId);
      const addTask = new AddNpvrTask({
        event_id: eventId,
        event_alf_id: event_alf_id,
        channel_id: channelId,
        payway_token: paywayToken,
        group_id: groupId
      });
      const response = await RequestManager.addRequest(addTask);
      let result = false;
      if (this.validateResponse(response)) {
        const {
          recording_id = null,
          recording_status = null,
          actions = null
        } = this.getRecordingFromResponse(response);
        if (recording_id) {
          await EPGUtil.updateRecordings([
            {
              id_composite: `${groupId}${event_alf_id || eventId}`,
              id: event_alf_id || eventId,
              group_id: groupId,
              recording_status: recording_status,
              recording_id: `${recording_id}`
            }
          ]);
          result = recording_id;
          this.recordings[event_alf_id || eventId] = {
            id: event_alf_id || eventId,
            group_id: groupId,
            recording_status: recording_status,
            recording_id: `${recording_id}`,
            actions: actions,
            recordType: isEpisode ? 'episode' : 'program'
          };
          this.withDelay(() => {
            UpdateMiniAfterRecordObserver.fire();
            RecordingsNotification.fire({eventId, groupId, channelId, isEpisode, recording_status });
            if (Utils.isFullEpgPersistanceOpen()) {
              recordFullObserver.fire(this.recordings[event_alf_id || eventId]);
            }
          }, 1000);
          convertEventLiveTORecord.fire({id:eventId,type: SearchConstants.RECORDING});
          this.showRecordingNotification(response, isEpisode, false,null, cbButton);
          // if(!isEpisode){
          //   this.showRecordingNotification(response);
          // }else{
          //   this.showRecordingNotificationEpisode(response);
          // }
        }
      } else {
        throw response;
      }
      return new Promise(resolve => resolve(result));
    } catch (e) {
      if(!isEpisode){
        this.showRecordingNotification(e, false, false, null, cbButton);
      } else {
        this.showRecordingNotificationEpisode(e, cbButton, true, false);
      }
      logger.debug('[NpvrUploader] add error:', e);
      return new Promise(resolve => resolve(false));
    }
  }

  async updateStatusFromListSerie(serieId, groupId, status =  false, clearRecordingId = false, ext_season_id = null) {
    try {
        let result = [];
        const paramsList =  {
          serieId: serieId,
          seasonId : ext_season_id,
          groupId: groupId,
          language: 1
        }
        const seriesListNpvrTask = new SeriesListNpvrTask(paramsList);
        const resultSerie = await RequestManager.addRequest(seriesListNpvrTask);
        if(resultSerie && resultSerie.response && resultSerie.response.recordings && Array.isArray(resultSerie.response.recordings)){
          const listIds = resultSerie.response.recordings.map(record => {
          const eventId_record = (record && record.channel && record.channel.event && record.channel.event.event_alf_id) ||
                                (record && record.channel && record.channel.event && record.channel.event.event_id) || null;
            return {
            id_composite: `${groupId}${eventId_record}`,
            id: eventId_record,
            group_id: groupId,
            recording_status: NpvrUtil.parseStringStatusToInt(status ?  status : record.status),
            recording_id: clearRecordingId ? '' :record.record_id,
            actions: record.actions ? record.actions : null
            }
          });
          result = listIds.map(object => ({ ...object }));
          if(listIds && Array.isArray(listIds)) {
            for(const rec in listIds){
              const currentEvent = listIds[rec];
              if(clearRecordingId){
                delete this.recordings[currentEvent.id]
              }
              else{
                this.recordings[currentEvent.id] = {
                  id: currentEvent.id,
                  group_id: currentEvent.group_id,
                  recording_status: currentEvent.recording_status,
                  recording_id: currentEvent.recording_id,
                  actions: currentEvent.actions ? currentEvent.actions : null,
                  recordType: 'serie'
                };
              }
            }
            const newIds = listIds.map(object => ({ ...object }));
            convertEventLiveTORecord.fire({from:SearchConstants.FROM_SERIES, list: newIds});
            await EPGUtil.updateRecordings(listIds);
          }
        }
        return new Promise(resolve => resolve(result));
    }catch (e){
      return new Promise(resolve => resolve([]));
    }
  }


  async updateStatusFromListSerieFromURl(serie, clearRecordingId = false) {
      const {actions: {episodes:url_list_episodes = null}, group_id: groupId= null} = serie;
      try {
        if(!url_list_episodes){
          return;
        }
        let result = [];
        let { recordings = []} = await this.listByCompleteUrl(url_list_episodes);
        recordings = this.filterErrorRecordings(recordings);

        if(recordings && Array.isArray(recordings)){
          const listIds = recordings.map(record => {
            const { status = null} = record;
            const eventId_record = (record && record.channel && record.channel.event && record.channel.event.event_alf_id) ||
                                  (record && record.channel && record.channel.event && record.channel.event.event_id) || null;
            return {
              id_composite: `${groupId}${eventId_record}`,
              id: eventId_record,
              group_id: groupId,
              recording_status: NpvrUtil.parseStringStatusToInt(status),
              recording_id: clearRecordingId ? '' :record.record_id,
              actions: serie.actions ? serie.actions : null
            }
          });
          result = listIds.map(object => ({ ...object }));
          if(listIds && Array.isArray(listIds)) {
            for(const rec in listIds){
              const currentEvent = listIds[rec];
              if(currentEvent && currentEvent.id){
                this.recordings[currentEvent.id] = {
                  id: currentEvent.id,
                  group_id: currentEvent.group_id,
                  recording_status: currentEvent.recording_status,
                  recording_id: currentEvent.recording_id,
                  actions: serie.actions ? serie.actions : null,
                  recordType: 'serie'
                };
              }
            }
            await EPGUtil.updateRecordings(listIds);
          }
        }
        return new Promise(resolve => resolve(result));
    }catch (e){
      return new Promise(resolve => resolve([]));
    }
  }

  async addSerie(eventId, event_alf_id, groupId, channelId, serieId, cbButton = null, ext_season_id = null) {
    let resp = {};
    try {
      logger.debug(
        `[NpvrUploader] add eventId: ${eventId}, event_alf_id: ${event_alf_id}, groupId: ${groupId}, channelId: ${channelId}, serieId:${serieId}`
      );
      const paywayToken = await new ChannelSingleton().getPaywayToken(groupId);
      const addTask = new SeriesAddNpvrTask({
        event_id: eventId,
        event_alf_id: event_alf_id,
        channel_id: channelId,
        payway_token: paywayToken,
        group_id: groupId
      });
      const response = await RequestManager.addRequest(addTask);
      if (this.validateResponse(response)) {
        resp = this.getRecordingFromResponse(response);
        const {
          recording_id = null,
          recording_status = null
        } = resp;
        if (recording_id) {
          const result = await this.updateStatusFromListSerie(serieId,groupId, false, false, ext_season_id);
          this.withDelay(() => {
            UpdateMiniAfterRecordObserver.fire();
            RecordingsNotification.fire({eventId, groupId, channelId, serieId, recording_status });
            if (Utils.isFullEpgPersistanceOpen()) {
              recordFullObserver.fire(result);
            }
          }, 1000);
          this.showRecordingNotificationSerie(response, cbButton);
        }
      } else {
        throw response
      }
      return new Promise(resolve => resolve(resp));
    } catch (e) {
      this.showRecordingNotificationSerie(e, cbButton, false, true);
      logger.debug('[NpvrUploader] add error:', e);
      return new Promise(resolve => resolve(false));
    }
  }

  async deleteByUrl(url, groupId, eventId = null, eventAlfId = null) {
    logger.debug(
      `[NpvrUploader] deleteByUrl url: ${url}, groupId: ${groupId}, eventId: ${eventId}`
    );
    try {
      const simpleRequest = new SimpleGetRequestTask(url, false);
      const response = await RequestManager.addRequest(simpleRequest);
      let result = false;
      if ((eventAlfId || eventId) && this.validateResponse(response)) {
        result = await EPGUtil.updateRecordings([
          {
            id_composite: `${groupId}${eventAlfId || eventId}`,
            id: eventAlfId || eventId,
            group_id: groupId,
            recording_status: NPVR_RECORDABLE_EVENT_STATUS,
            recording_id: ''
          }
        ]);
        delete this.recordings[eventAlfId || eventId];
        this.withDelay(() =>{
          UpdateMiniAfterRecordObserver.fire();
          RecordingsNotification.fire({eventId, recording_status: NPVR_RECORDABLE_EVENT_STATUS, groupId });
        }, 1000);
      }
      else{
        this.withDelay(() => {
          UpdateMiniAfterRecordObserver.fire();
          RecordingsNotification.fire({eventId, recording_status: NPVR_RECORDABLE_EVENT_STATUS, groupId });
        }, 1000);
      }
      return new Promise(resolve => resolve(result));
    } catch (e) {
      logger.error('[NpvrUploader] deleteByUrl error:', e);
      return new Promise(resolve => resolve(false));
    }
  }

  async delete(eventId, eventAlfId, groupId, recordingId, current_status = false, cbButton = null) {
    logger.debug(
      `[NpvrUploader] delete eventId: ${eventId}, groupId: ${groupId}, recordingId: ${recordingId}`
    );
    try {
      const deleteTask = new RemoveNpvrTask({
        user_token: this.user.user_token,
        record_id: recordingId
      });
      const response = await RequestManager.addRequest(deleteTask);
      let result = false;
      if (this.validateResponse(response)) {
        result = await EPGUtil.updateRecordings([
          {
            id_composite: `${groupId}${eventAlfId || eventId}`,
            id: eventAlfId || eventId,
            group_id: groupId,
            recording_status: NPVR_RECORDABLE_EVENT_STATUS,
            recording_id: ''
          }
        ]);
        const recordType = this.getRecordingTypeByEventId(eventAlfId || eventId) || 'program';
        delete this.recordings[eventAlfId || eventId];
        this.withDelay(() => {
          RecordingsNotification.fire({eventId, recording_status: NPVR_RECORDABLE_EVENT_STATUS, groupId });
          UpdateMiniAfterRecordObserver.fire();
        }, 1000);

        let isEpisode = false;
        let isSerie = false;

        if(recordType === 'episode') {
          isEpisode = true;
        }
        if(recordType === 'serie') {
          isSerie = true;
        }

        convertEventLiveTORecord.fire({id:eventId,type: SearchConstants.EVENT});
        this.showRecordingNotification(response, isEpisode, true, current_status, cbButton, isSerie)
      }
      return new Promise(resolve => resolve(result));
    } catch (e) {
      logger.debug('[NpvrUploader] delete error:', e);
      return new Promise(resolve => resolve(false));
    }
  }

  async listByCompleteUrl(url) {
    logger.debug(
      `[NpvrUploader] listByCompleteUrl url: ${url}`
    );
    let result = {};
    try {
      const simpleRequest = new SimpleGetRequestTask(url, false);
      simpleRequest.setShowErrorModal(false);
      const response = await RequestManager.addRequest(simpleRequest);
      if (response && response.response) {
        result = response.response;
      }
      return new Promise(resolve => resolve(result));
    } catch (e) {
      logger.error('[NpvrUploader] deleteByUrl error:', e);
      return new Promise(resolve => resolve(result));
    }
  }

  async list() {
    try {
      const listTask = new ListNpvrTask({});
      const response = await RequestManager.addRequest(listTask);
      logger.debug('[NpvrUploader] list ');
      let result = {};
      if (response && response.response) {
        result = response.response;
        logger.debug('::::: [NpvrUploader] list result', result);
      }
      return new Promise(resolve => resolve(result));
    } catch (e) {
      logger.error('[NpvrUploader] list error:', e);
      return new Promise(resolve => resolve({}));
    }
  }

  async listFromUrl(url) {
    try {
      const listTask = new ListNpvrFromUrlTask({ }, url);
      const response = await RequestManager.addRequest(listTask);
      logger.debug('[NpvrUploader] listFromUrl ');
      let result = [];
      if (response && response.response) {
        result = response.response;
      }
      return new Promise(resolve => resolve(result));
    } catch (e) {
      logger.error('[NpvrUploader] listFromUrl error:', e);
      return new Promise(resolve => resolve([]));
    }
  }

  async listByStatus(status) {
    try {
      const listTask = new ListNpvrTask({ status });
      const response = await RequestManager.addRequest(listTask);
      logger.debug('[NpvrUploader] listByStatus ');
      let result = [];
      if (response && response.response) {
        result = response.response;
      }
      return new Promise(resolve => resolve(result));
    } catch (e) {
      logger.error('[NpvrUploader] listByStatus error:', e);
      return new Promise(resolve => resolve([]));
    }
  }

  isEventSerie(event) {
    if(event && event.ext_series_id){
      return true;
    }
    return false;
  }

   showModalSeries(event, callback = null){
    const episodeParams = {
      event_id: event.id || event.eventId || null,
      groupId: event.group_id ||  event.groupId || null,
      channel_id: event.channel_id || event.eventNumber || null,
      // channel_id: event.channel_id || event.eventNumber || null,
      serieId: event.serieId || event.ext_series_id || null
    };
    const modalProps = {
      onRecordSerie: async () => {
        const recordingId  = await this.addSerie(episodeParams.event_id,episodeParams.groupId,episodeParams.channel_id, episodeParams.serieId);
        if(recordingId){
          callback && (typeof callback === 'function') && callback(recordingId);
        }
      },
      onRecordEpisode: async () => {
        const recordingId  = await this.add(episodeParams.event_id,episodeParams.groupId,episodeParams.channel_id, true);
        if(recordingId){
          callback && (typeof callback === 'function') && callback(recordingId);
        }
      }
    };

    store.dispatch(showModal({
      modalType: MODAL_RECORD_SERIES,
      modalProps: modalProps
    }));
  }
}

export default new NpvrUploader();



// WEBPACK FOOTER //
// ./src/AAF/Npvr/NpvrUploader.js